import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button,
    Avatar
} from '@mui/material';

import {
    Security,
    Visibility,
    PrivacyTip,
    Warning,
    CheckCircle,
    LocationOn,
    Error,
    PersonSearch,
    Home,
    CameraAlt,
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: { xs: 1, sm: 3 } }}>
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    導入：ルームシェアと防犯カメラのリアル
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('necessity')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    防犯カメラの必要性と現代ルームシェア事情
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('privacy')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    プライバシー保護のポイント
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('placement')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    設置場所の工夫とおすすめポイント
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('cases')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    実際に起きたトラブル事例と対策
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('summary')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    まとめ：安心と信頼のルームシェアへ
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入部分 */}
            <Box id="introduction" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    導入：ルームシェアと防犯カメラのリアル
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェアは、経済的なメリットや多様な人間関係を築ける魅力的な住まい方として、近年ますます注目を集めています。しかし、他人と空間を共有するからこそ起こる「防犯」と「プライバシー」という二つのテーマは、快適な共同生活を続けるうえで避けて通れない課題です。本記事では、防犯カメラの設置がなぜ必要なのか、そしてプライバシーを守りつつトラブルを未然に防ぐためのポイントを、専門的な視点から分かりやすく解説します。
                </Typography>
                <Box sx={{ my: 3, textAlign: 'center' }}>

                </Box>
            </Box>

            {/* 防犯カメラの必要性 */}
            <Box id="necessity" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    防犯カメラの必要性と現代ルームシェア事情
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                    <Grid item xs={12} md={7}>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            ルームシェアでは、複数人が同じ住居で生活するため、不審者の侵入や盗難、外部からのトラブルリスクが単身生活より高まる傾向があります。特に、都心部や駅近物件では、空き巣や部外者の出入りなどが懸念されることも。こうしたリスクを低減し、「みんなが安心できる空間」を守るために、防犯カメラの設置は有効な対策の一つです。
                        </Typography>
                        <List>
                            <ListItem>
                                <ListItemIcon>
                                    <Security color="primary" />
                                </ListItemIcon>
                                <ListItemText primary="外部からの不審者対策" secondary="玄関や共有部分への侵入を抑止する効果があります。" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <Visibility color="primary" />
                                </ListItemIcon>
                                <ListItemText primary="トラブル発生時の証拠保全" secondary="物品の紛失や事故があった場合、映像記録が役立ちます。" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <Home color="primary" />
                                </ListItemIcon>
                                <ListItemText primary="住人同士の安心感向上" secondary="「見守られている安心感」が心理的なセーフティネットとなります。" />
                            </ListItem>
                        </List>
                    </Grid>
                    <Grid item xs={12} md={5} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Box sx={{ width: '100%' }}>

                        </Box>
                    </Grid>
                </Grid>
                <Box sx={{ mt: 2 }}>
                    <Chip label="シェアハウス防犯" color="primary" variant="outlined" sx={{ mr: 1 }} />
                    <Chip label="トラブル予防" color="primary" variant="outlined" />
                </Box>
            </Box>

            {/* プライバシー保護のポイント */}
            <Box id="privacy" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    プライバシー保護のポイント
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    防犯カメラは安心感をもたらしますが、同時にプライバシーの侵害というデリケートな問題も生じます。住人の信頼関係を損なわないために、以下の点に必ず配慮しましょう。
                </Typography>
                <Paper elevation={0} sx={{ bgcolor: '#f9fbe7', p: 2, mb: 2, borderRadius: 2 }}>
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <PrivacyTip color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary={<b>設置前の「全員合意」</b>}
                                secondary="カメラ設置は必ず住人全員の同意を得てから実施しましょう。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircle color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary={<b>プライベート空間は絶対NG</b>}
                                secondary="個室やバス・トイレ・脱衣所にはカメラを絶対に設置しないこと。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <PersonSearch color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary={<b>設置場所・録画範囲の明示</b>}
                                secondary="どこに、どんな目的で設置するのかを住人に明確に説明しましょう。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <Warning color="error" />
                            </ListItemIcon>
                            <ListItemText
                                primary={<b>映像の管理者・閲覧権限の明確化</b>}
                                secondary="録画データの管理者を決め、勝手な閲覧やSNS投稿の禁止を徹底します。"
                            />
                        </ListItem>
                    </List>
                </Paper>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    プライバシー配慮は信頼関係の礎。万一のトラブル時にも「公平・客観的な運用」を心がけましょう。
                </Typography>
            </Box>

            {/* 設置場所の工夫とおすすめポイント */}
            <Box id="placement" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    設置場所の工夫とおすすめポイント
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            防犯カメラの設置場所は「安全性」と「プライバシー」のバランスが重要です。住人の生活を過度に監視しないためにも、以下のような場所を選びましょう。
                        </Typography>
                        <List>
                            <ListItem>
                                <ListItemIcon>
                                    <LocationOn color="primary" />
                                </ListItemIcon>
                                <ListItemText
                                    primary="玄関・エントランス"
                                    secondary="外部からの出入りを記録。最も多く採用される設置ポイントです。"
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <CameraAlt color="primary" />
                                </ListItemIcon>
                                <ListItemText
                                    primary="郵便受け・宅配ボックス付近"
                                    secondary="荷物の盗難やトラブルを防ぐために効果的です。"
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <Home color="primary" />
                                </ListItemIcon>
                                <ListItemText
                                    primary="共有リビングや廊下"
                                    secondary="人の出入りが多い場所。ただし、くつろぎ空間には配慮を。"
                                />
                            </ListItem>
                        </List>
                        <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
                            「カメラがあることを明示し、死角を作らない」ことがトラブル防止のコツです。
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ textAlign: 'center' }}>

                        </Box>
                    </Grid>
                </Grid>
                <Box sx={{ mt: 2 }}>
                    <Chip label="設置アイデア" color="primary" variant="outlined" sx={{ mr: 1 }} />
                    <Chip label="死角対策" color="primary" variant="outlined" />
                </Box>
            </Box>

            {/* 実際に起きたトラブル事例と対策 */}
            <Box id="cases" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    実際に起きたトラブル事例と対策
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェアにおける防犯カメラの設置を巡っては、実際に様々なトラブルも報告されています。ここではよくある事例と、その解決策をまとめました。
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Card sx={{ mb: 2, borderRadius: 2, boxShadow: 1 }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Error color="error" sx={{ mr: 1 }} />
                                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>事例1：勝手な録画データ閲覧</Typography>
                                </Box>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    部屋主がルームメイトの同意なく、カメラ映像を個人的に閲覧していたことが判明。プライバシー侵害の疑念から住人同士の信頼が大きく損なわれ、ルームシェア解消に。
                                </Typography>
                                <Divider sx={{ my: 1 }} />
                                <List dense>
                                    <ListItem>
                                        <ListItemIcon>
                                            <CheckCircle color="success" />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary="解決策：管理者と閲覧ルールの明確化"
                                            secondary="録画データの閲覧はトラブル時のみ・複数人立ち会いで実施"
                                        />
                                    </ListItem>
                                </List>
                            </CardContent>
                        </Card>
                        <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Error color="error" sx={{ mr: 1 }} />
                                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>事例2：カメラの死角を狙った盗難</Typography>
                                </Box>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    共有スペースのカメラ設置範囲外で頻発した小物の盗難。住人同士の疑心暗鬼を生み、最終的にカメラ増設や設置場所の見直しが行われました。
                                </Typography>
                                <Divider sx={{ my: 1 }} />
                                <List dense>
                                    <ListItem>
                                        <ListItemIcon>
                                            <CheckCircle color="success" />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary="解決策：死角の見直しとカメラ位置の最適化"
                                            secondary="設置場所の定期点検や、死角を減らすレイアウト改善"
                                        />
                                    </ListItem>
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ textAlign: 'center', mt: { xs: 2, md: 0 } }}>

                        </Box>
                    </Grid>
                </Grid>
                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 2 }}>
                    防犯カメラの運用は「全員参加型」が理想。ルールを明文化し、定期的な見直しがトラブル予防の秘訣です。
                </Typography>
            </Box>

            {/* まとめ */}
            <Box id="summary" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    まとめ：安心と信頼のルームシェアへ
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェアでの防犯カメラ設置は、安心と安全のための有効な選択肢ですが、プライバシー配慮や住人全員の納得感も不可欠です。設置前の「話し合い」や「ルールづくり」をしっかり行い、全員が安心できる空間を実現しましょう。防犯カメラは「監視」ではなく「信頼」を守るためのツール。健やかで心地よいシェア生活のために、ぜひ本記事のポイントを参考にしてみてください。
                </Typography>
                <Paper elevation={0} sx={{ bgcolor: '#e3f2fd', p: 2, borderRadius: 2 }}>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        <Security color="primary" sx={{ mr: 1, verticalAlign: 'middle' }} />
                        「防犯」と「プライバシー」を両立させた住環境こそが、みんなの笑顔を支える基盤です。
                    </Typography>
                </Paper>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-security-camera-privacy',
    slug: 'roomshare-security-camera-privacy',
    title: 'ルームシェアの「防犯カメラ」設置とプライバシー問題',
    excerpt: '防犯カメラの必要性や設置時のプライバシー保護、設置場所の工夫、実際のトラブル事例と対策を解説します。',
    coverImage: '/images/blog/cover-roomshare-security-camera_roomshare-security-camera-privacy.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つルームメイトたちが楽しく会話をしている様子。安全と信頼、そして快適な共同生活の両立をイメージさせる雰囲気',
    publishedAt: '2024-06-14T00:00:00.000Z',
    isPublished: true,
    categories: ['ルームシェア', '防犯', '暮らしの知恵'],
    tags: ['防犯カメラ', 'プライバシー', 'シェアハウス', '住人トラブル'],
    author: {
        name: '山本 達也',
        avatar: '/images/avatars/expert-yamamoto.jpg',
        bio: '住宅・防犯分野の情報発信を通じて、安心・快適な暮らしをサポート。ルームシェア経験者としての現場目線を大切にしています。',
        profilePicture: '/images/avatars/expert-yamamoto.jpg'
    },
    viewCount: 1320,
    contentComponent: PostContent
};

export default post;